/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../$$_gendir/node_modules/@angular/material/sidenav/typings/index.ngfactory';
import * as i2 from '@angular/material/core';
import * as i3 from '@angular/material/sidenav';
import * as i4 from '@angular/cdk/bidi';
import * as i5 from '@angular/router';
import * as i6 from '../../../../app/layouts/auth/auth-layout.component';
const styles_AuthLayoutComponent:any[] = ['[_nghost-%COMP%]     .mat-drawer-content {padding: 0;} .mat-drawer-container[_ngcontent-%COMP%] {z-index: 1000}'];
export const RenderType_AuthLayoutComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:0,
    styles:styles_AuthLayoutComponent,data:{}});
export function View_AuthLayoutComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),8,'mat-sidenav-container',
      [['class','mat-drawer-container mat-sidenav-container']],(null as any),(null as any),
      (null as any),i1.View_MatSidenavContainer_0,i1.RenderType_MatSidenavContainer)),
      i0.ɵdid(16384,(null as any),0,i2.MatPrefixRejector,([] as any[]),(null as any),
          (null as any)),i0.ɵdid(1228800,(null as any),2,i3.MatSidenavContainer,[[2,
          i4.Directionality],i0.ElementRef,i0.Renderer2,i0.NgZone,i0.ChangeDetectorRef],
          (null as any),(null as any)),i0.ɵqud(603979776,1,{_drawers:1}),i0.ɵqud(335544320,
          2,{_content:0}),(_l()(),i0.ɵted(2,['\n  '])),(_l()(),i0.ɵeld(16777216,(null as any),
          2,1,'router-outlet',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),i0.ɵdid(212992,(null as any),0,i5.RouterOutlet,
          [i5.ChildrenOutletContexts,i0.ViewContainerRef,i0.ComponentFactoryResolver,
              [8,(null as any)],i0.ChangeDetectorRef],(null as any),(null as any)),
      (_l()(),i0.ɵted(2,['\n']))],(_ck,_v) => {
    _ck(_v,7,0);
  },(null as any));
}
export function View_AuthLayoutComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'app-layout',([] as any[]),
      (null as any),(null as any),(null as any),View_AuthLayoutComponent_0,RenderType_AuthLayoutComponent)),
      i0.ɵdid(49152,(null as any),0,i6.AuthLayoutComponent,([] as any[]),(null as any),
          (null as any))],(null as any),(null as any));
}
export const AuthLayoutComponentNgFactory:i0.ComponentFactory<i6.AuthLayoutComponent> = i0.ɵccf('app-layout',
    i6.AuthLayoutComponent,View_AuthLayoutComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9jaHJvbm9jYXNoVjMvdWFjL3dlYmFwcC1jbGsvc3JjL2FwcC9sYXlvdXRzL2F1dGgvYXV0aC1sYXlvdXQuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci9jaHJvbm9jYXNoVjMvdWFjL3dlYmFwcC1jbGsvc3JjL2FwcC9sYXlvdXRzL2F1dGgvYXV0aC1sYXlvdXQuY29tcG9uZW50LnRzIiwibmc6Ly8vdmFyL2Nocm9ub2Nhc2hWMy91YWMvd2ViYXBwLWNsay9zcmMvYXBwL2xheW91dHMvYXV0aC9hdXRoLWxheW91dC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci9jaHJvbm9jYXNoVjMvdWFjL3dlYmFwcC1jbGsvc3JjL2FwcC9sYXlvdXRzL2F1dGgvYXV0aC1sYXlvdXQuY29tcG9uZW50LnRzLkF1dGhMYXlvdXRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bWF0LXNpZGVuYXYtY29udGFpbmVyPlxuICA8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+XG48L21hdC1zaWRlbmF2LWNvbnRhaW5lcj4iLCI8YXBwLWxheW91dD48L2FwcC1sYXlvdXQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO01BQUE7YUFBQTtVQUFBLHNCQUFBOzJCQUFBO1VBQUE7VUFBQSxnQkFBdUIsNkJBQ3JCO1VBQUE7VUFBQSxxQ0FBQTtVQUFBO2NBQUE7TUFBK0I7SUFBL0I7Ozs7b0JDREY7TUFBQTthQUFBO1VBQUE7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/layouts/auth/auth-layout.component.ngfactory.ts